<template>
  <button>{{ title }}</button>
</template>

<script>
export default {
  props: ['title'],
}
</script>

<style lang="scss" scoped></style>